import Swiper, {
    Navigation,
    Pagination,
    Mousewheel,
    A11y,
    EffectFade,
    Keyboard,
    Autoplay,
    Lazy,
    Scrollbar,
} from 'swiper';

Swiper.use([Navigation, Pagination, Mousewheel, A11y, EffectFade, Keyboard, Autoplay, Lazy, Scrollbar]);

const STRINGS = document.body.dataset.slider.split(',');
export const defaultSwiperOptions = {
    a11y: true,
    keyboard: true,
    autoplay: false,
    a11y: {
        enabled: true,
        paginationBulletMessage: STRINGS[0],
        prevSlideMessage: STRINGS[1],
        nextSlideMessage: STRINGS[2],
    },
};

function initDecorLightboxSlider() {
    [...document.querySelectorAll('.decor-overview-wrapper')].forEach((container) => {
        const decorLightbox = container.querySelector('.decor-lightbox');

        if (decorLightbox) {
            const decorBoxes = container.querySelectorAll('.decor-box');

            [...decorBoxes].forEach((box) => {
                box.addEventListener('click', function () {
                    const sliderContainer = cloneTemplate(container, getVisibleDecorIds(decorBoxes));
                    if (!sliderContainer) {
                        console.warn('No slider container element found');
                        return;
                    }
                    const activeDecorId = box.dataset.idDecor;

                    const { mainSlider, thumbnailSlider } = initSliders(sliderContainer, activeDecorId);

                    const decorLightboxCloseButton = container.querySelector('.decor-lightbox__close');

                    if (decorLightbox) {
                        decorLightbox.style.display = 'block';
                        document.body.style.overflow = 'hidden';

                        decorLightboxCloseButton.addEventListener('click', function () {
                            if (decorLightbox) {
                                decorLightbox.style.display = 'none';
                                document.body.style.overflow = 'auto';
                            }

                            // empty slides and destroy slider instances
                            mainSlider.destroy();
                            thumbnailSlider.destroy();
                            sliderContainer.innerHTML = '';
                        });
                    }
                });
            });
        }
    });
}

function cloneTemplate(decorLightbox, visibleDecorIds) {
    const template = decorLightbox.querySelector('.js-decor-slider-template');
    const sliderContainer = decorLightbox.querySelector('.js-decor-lightbox-slider-container');

    if (template && sliderContainer) {
        const clone = template.content.cloneNode(true);
        sliderContainer.appendChild(clone);

        // remove all slides that are not visible in filter
        const sliderItems = sliderContainer.querySelectorAll('.decor-lightbox-item');
        const thumbsItems = sliderContainer.querySelectorAll('.decor-lightbox-item-thumbs');
        [...sliderItems].forEach((item) => {
            if (!visibleDecorIds.includes(item.dataset.idDecor)) {
                item.remove();
            }
        });
        [...thumbsItems].forEach((item) => {
            if (!visibleDecorIds.includes(item.dataset.idDecor)) {
                item.remove();
            }
        });
    }

    return sliderContainer;
}

function initSliders(sliderContainer, activeDecorId) {
    const sliderEl = sliderContainer.querySelector('.decor-lightbox-slider');
    const thumbsEl = sliderContainer.querySelector('.decor-lightbox-slider-thumbs');
    if (!sliderEl || !thumbsEl) {
        console.warn('No slider element found');
    }

    const mainSlider = new Swiper(sliderEl, {
        ...defaultSwiperOptions,
        slidesPerView: 1,
        spaceBetween: 30,
        thumbs: {
            swiper: thumbnailSlider,
        },
        slideClass: 'decor-lightbox-item',
        pagination: false,
        navigation: {
            nextEl: '.decor-lightbox-slides-wrapper .swiper-button-next--middle',
            prevEl: '.decor-lightbox-slides-wrapper .swiper-button-prev--middle',
        },
    });

    const thumbnailSlider = new Swiper(thumbsEl, {
        ...defaultSwiperOptions,
        slideClass: 'decor-lightbox-item-thumbs',
        slidesPerView: 4,
        spaceBetween: 0,
        touchRatio: 0.2,
        centeredSlides: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        freeMode: true,
        pagination: false,
        navigation: {
            nextEl: '.decor-lightbox-slider-thumbs .swiper-button-next',
            prevEl: '.decor-lightbox-slider-thumbs .swiper-button-prev',
        },
        breakpoints: {
            1025: {
                slidesPerView: 7,
            },
        },
    });

    const index = [...sliderEl.querySelectorAll('.decor-lightbox-item')].findIndex((slide) => {
        return slide.dataset.idDecor === activeDecorId;
    });

    // sync both sliders
    mainSlider.on('slideChange', () => {
        thumbnailSlider.slideTo(mainSlider.activeIndex);
    });
    thumbnailSlider.on('slideChange', () => {
        mainSlider.slideTo(thumbnailSlider.activeIndex);
    });

    mainSlider.slideTo(index);
    thumbnailSlider.slideTo(index);

    return {
        mainSlider,
        thumbnailSlider,
    };
}

function getVisibleDecorIds(decorBoxes) {
    return [...decorBoxes]
        .map((box) => {
            if (box.style.display !== 'none') {
                return box.dataset.idDecor;
            }
        })
        .filter((box) => box !== undefined);
}

initDecorLightboxSlider();
